export default __webpack_public_path__ + "static/yongyang2-ef6a1edd559746e8c3195558ea6f1cc5.jpg";